export default __webpack_public_path__ + "static/SSSpyView_screenshot-1@mob-9e83ddddbdfa175954ad0c14e6abe2e6.jpg";